import React from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'

import Avatar from 'material-ui/Avatar';
import Button from 'material-ui/Button'
import TextField from 'material-ui/TextField';
import Input, { InputLabel } from 'material-ui/Input'
import {FormControl, FormControlLabel, FormHelperText} from 'material-ui/Form'
import Select from 'material-ui/Select'
import { MenuItem } from 'material-ui/Menu'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { validateFormData } from '../../../common/formtool'
import withRole from '../../hoc/role'
import { ROLES_CLIENT } from '../../../common/constants';
import Checkbox from "material-ui/Checkbox";


const MeasurementUnitByRole = withRole((props) => {
  return (
    <React.Fragment>{props.children}</React.Fragment>
  )
}, ROLES_CLIENT)

class ProfileGeneral extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: {},
      errors: {},
      user: {
        firstname: "",
        lastname: "",
        enabled: true,
        language: "",
        email: "",
        roles: [''],
        rolesName: [''],
        units: "",
        mfaEnabled: false
      },
      isUpdateSettingBtnDisabled: true
    }
    this.onChange = this.onChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  onChange(e) {
    let user = { ...this.state.user }

    if (e.target.name === 'mfaEnabled') {
      user[e.target.name] = e.target.checked
    } else {
      user[e.target.name] = e.target.value
    }

    let errors = { ...this.state.errors }
    errors = {
      ...errors,
      [e.target.name]: false
    }
    this.setState({ user: user, errors })
    let { isUpdateSettingBtnDisabled } = this.state
    if (isUpdateSettingBtnDisabled) {
      this.setState({ isUpdateSettingBtnDisabled: false })
    }
  }
  handleSubmit() {
    let user = { ...this.state.user }

    let validationData = {
      firstname: {
        required: this.props.translate('formfield_error_general_required')
      },
      lastname: {
        required: this.props.translate('formfield_error_general_required')
      },
      email: {
        required: this.props.translate('formfield_error_general_required'),
        validEmail: this.props.translate('user_email_error')
      },
      language: {
        required: this.props.translate('formfield_error_general_required'),
      }
    }

    if (ROLES_CLIENT.filter((n) => user.roles.includes(n)).length) {
      validationData.units = {
        required: this.props.translate('formfield_error_general_required'),
      }
    }

    let errors = validateFormData(this.state.user, validationData);
    const missingFieldName = Object.keys(errors)[0]
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0]
      textField && textField.focus()
    }

    if (Object.keys(errors).length) {
      this.setState({ errors: errors })
    } else {
      let self = this;
      let email = self.state.user.email;
      this.props.update(user).then((resp) => {
        self.setState({
          error: {},
          isUpdateSettingBtnDisabled: true
        })
      }).catch((err) => {
        if (err.errors === 'error_duplicateuser') {
          self.setState({
            error: {
              type: 'error_duplicateuser',
              data: email
            }
          })
        }
      })
      if (!this.state.isUpdateSettingBtnDisabled) {
        window.scrollTo(0,0);
      }
    }
  }
  getUpdateError(error) {
    if (error.type === "error_duplicateuser") {
      return (
        <div className={this.props.classes.error}>
          <Typography type="subheading" color="inherit">
            {this.props.translate('error_duplicateuser_title')}
          </Typography>
          <Typography type="body1" color="inherit">
            {this.props.translate('error_duplicateuser_desc', { email: error.data })}
          </Typography>
        </div>
      )
    }
  }
  render() {
    const {
      classes,
      languages,
      translate,
      impersonating
    } = this.props

    const {
      user,
      error,
      errors,
      isUpdateSettingBtnDisabled
    } = this.state

    return (
      <Paper className={classes.paper}>
        <Grid container direction="row" justify="flex-start" alignItems="center">
          <Grid item xs={3}>
            <Avatar className={classes.avatar}>
              {user.firstname && user.firstname.charAt(0)}{user.lastname && user.lastname.charAt(0)}
            </Avatar>
          </Grid>
          <Grid item xs={9} >
            <Typography type="title" gutterBottom>
              {user.email}
            </Typography>
            <Typography type="subheading">
              {user.roles[0] !== '' && translate(user.roles[0])}
            </Typography>
          </Grid>
        </Grid>
        {error && this.getUpdateError(error)}
        <TextField
          required
          error={errors.firstname ? true : false}
          name="firstname"
          label={translate("user_firstname")}
          margin="normal"
          fullWidth
          value={user.firstname}
          onChange={this.onChange}
          helperText={errors.firstname ? errors.firstname : translate("user_firstname_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={errors.lastname ? true : false}
          name="lastname"
          label={translate("user_lastname")}
          margin="normal"
          fullWidth
          value={user.lastname ? user.lastname : ''}
          onChange={this.onChange}
          helperText={errors.lastname ? errors.lastname : translate("user_lastname_help")}
          disabled={impersonating}
        />
        <TextField
          required
          error={errors.email ? true : false}
          name="email"
          label={translate("user_email")}
          margin="normal"
          fullWidth
          value={user.email}
          onChange={this.onChange}
          helperText={errors.email ? errors.email : translate("user_email_help")}
          disabled={impersonating}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={user.mfaEnabled}
              onChange={this.onChange}
              name="mfaEnabled"
              color="primary"
              disabled={impersonating}
            />
          }
          label={translate("user_mfa_enabled")}
        />
        <FormControl
          fullWidth
          required
          margin="normal"
          error={errors.language ? true : false}
        >
          <InputLabel htmlFor="language">{translate("user_language")}</InputLabel>
          <Select
            value={user.language}
            onChange={this.onChange}
            input={<Input name="language" id="language" value={user.language} />}
            autoWidth={false}
            disabled={impersonating}
          >
            {
              languages.map((language, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={language.code}
                  >
                    {language.code}
                  </MenuItem>
                )
              })
            }
          </Select>
          <FormHelperText>{errors.language ? errors.language : translate("user_language_help")}</FormHelperText>
        </FormControl>
        <MeasurementUnitByRole>
          <FormControl
            fullWidth
            required
            margin="normal"
            error={errors.units ? true : false}
          >
            <InputLabel htmlFor="units">{translate("user_metric")}</InputLabel>
            <Select
              value={user.units}
              onChange={this.onChange}
              input={<Input name="units" id="units" value={user.units} />}
              autoWidth={false}
              disabled={impersonating}
            >
              <MenuItem
                value={'feet'}
              >
                {translate("user_metric_feet")}
              </MenuItem>
              <MenuItem
                value={'meters'}
              >
                {translate("user_metric_meter")}
              </MenuItem>
            </Select>
            <FormHelperText>{translate("user_metric_help")}</FormHelperText>
          </FormControl>
        </MeasurementUnitByRole>
        <Button raised
          fullWidth
          color="primary"
          className={classes.update}
          type="submit"
          onClick={this.handleSubmit}
          disabled={isUpdateSettingBtnDisabled || impersonating}
        >
          {translate("profile_update_settings")}
        </Button>
      </Paper>
    )
  }
  componentDidMount() {
    if (this.props.user) {
      let user = { ...this.props.user }
      this.setState({
        user
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.user && nextProps.user.id !== this.state.user.id) {
      let user = { ...nextProps.user }
      this.setState({
        user
      })
    }
  }
}

export default withStyles(styles)(ProfileGeneral)
